<template>
  <div class="wrapper">
      <label v-if="label" >{{label}}</label>
      <b-input-group>
          <autocomplete 
                 :source="uri"
                 :placeholder="place"
                 :input-class-required="classeRequired"
                 :results-display="obj => obj.CODIGONOME"
                 results-value="ID"
                 :disableInput="desabilitarInput"
                 @selected="onSelecionado"
                 @results="autoResults = $event.results"
                 @input="setId"
                 @clear="clearComplete({})" 
                 ref="auto">
                 <template slot="results">
                    <li v-if="$refs.auto && $refs.auto.hasError" class="autocomplete__results__item autocomplete__results__item--error">{{ $refs.auto.error }}</li>
                    <li v-for="(result, key) in autoResults"
                        :key="key"
                        @click.prevent="$refs.auto.select(result)"
                        class="autocomplete__results__item d-flex justify-content-between align-items-center result-item-premium"
                        :class="{'autocomplete__selected' : $refs.auto && $refs.auto.isSelected(key) }">
                        <div class="result-info text-left">
                            <span class="result-code">{{ result.ID }}</span>
                            <span class="result-name">{{ result.NOME }}</span>
                        </div>
                        <div class="result-stock text-right">
                            <b-badge v-if="vendaPorPecas" :variant="result.SALDO_PECAS > 0 ? 'success' : 'danger'" pill class="stock-badge shadow-sm">
                                <i class="fa fa-cubes mr-1"></i> {{ result.SALDO_PECAS || 0 }}
                            </b-badge>
                            <b-badge v-else :variant="result.SALDO_QUANT > 0 ? 'success' : 'danger'" pill class="stock-badge shadow-sm">
                                <i class="fa fa-balance-scale mr-1"></i> {{ (result.SALDO_QUANT || 0).toLocaleString('pt-BR', {minimumFractionDigits: 3}) }}
                            </b-badge>
                        </div>
                    </li>
                    <li v-if="$refs.auto && $refs.auto.noResults && !$refs.auto.isLoading && $refs.auto.isFocussed && !$refs.auto.hasError" class="autocomplete__results__item autocomplete__no-results">Não encontrado.</li>
                 </template>
           </autocomplete>
          <b-input-group-append v-if="!desabilitarInput">
            <b-btn variant="outline-secondary" v-b-modal="idModal">{{labelBotao}}
              <i class="fa fa-ellipsis-h"></i></b-btn>
          </b-input-group-append>
      </b-input-group>
    <b-modal :id="idModal"
             ref="modalProduto"
             title="Pesquisar Produtos (Visão de Estoque)"
             class="modal-primary"
             size="xl"
             scrollable 
             ok-title="Cancelar"
             ok-only
             @shown="clearModal">
      <b-card>
      <form @submit.stop.prevent="handleSubmit">
        <!-- <b-form-input type="text" placeholder="Enter your name" v-model="resultado"></b-form-input> -->
        <b-row>
          <!--/.col-->
          <b-col sm="8">
                <b-form-input type="text" id="nome" ref="edNomePesquisa" placeholder="Informe o Nome" v-model="pesquisa.nome"> </b-form-input>
          </b-col>
          <b-col sm="4">
            <!-- Button -->
            <b-button  type="submit" variant="outline-secondary" @click.stop.prevent="onSubmit()">
              <span>Pesquisar</span>
            </b-button> 
            <!-- Button -->
            <b-button type="reset"  variant="danger">
                  <i class="fa fa-ban"></i> Limpar
            </b-button>
          </b-col>
        </b-row>
      </form>
      </b-card>
      <b-row  v-if="this.items.length &&  this.items.length > 0">
        <b-col sm="12">
            <!-- Main table element -->
            <b-table striped hover 
                    head-variant="dark"
                    scrollable
                    responsive 
                    small
                    :busy.sync="isBusy" 
                    :items="items" 
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    @row-clicked="selecionar">
              <template #cell(ID)="item">{{item.item.ID}}</template>
              <template #cell(NOME)="item">{{item.item.NOME}}</template>
              <template #cell(SALDO_PECAS)="data">
                <b-badge :variant="data.value > 0 ? 'success' : 'danger'" pill>
                  {{ data.value }}
                </b-badge>
              </template>
              <template #cell(SALDO_QUANT)="data">
                {{ (data.value || 0).toLocaleString('pt-BR', {minimumFractionDigits: 3}) }}
              </template>
            </b-table>
            <div class="justify-content-center row my-1">
              <b-pagination size="md" :total-rows="this.items.length" :per-page="perPage" v-model="currentPage" />
            </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template> 
<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import Autocomplete from '../componentes/Autocomplete'

export default {
  props: {
    label: String,
    place: String,
    labelBotao: String,
    idInicial: Number,
    classeRequired: Boolean,
    desabilitarInput: Boolean,
    vendaPorPecas: {
      type: Boolean,
      default: true
    },
    idModal: {
      type: String,
      default() {
        return `modal-produto-${Math.random().toString(36).substr(2, 9)}`
      }
    }
  },
  data () {
    return {
      autoResults: [],
      resultado: '',
      pesquisa: {
        id: '',
        nome: ''
      },
      isLoading: false,
      status: false,
      isBusy: false,
      items: [],
      currentPage: 1,
      perPage: 20,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      uri: this.$http.defaults.baseURL.concat('api/protected/produto/autocompleteComEstoque?&texto='),
      classeBorda: 'teste'
    }
  },
  computed: {
    fields() {
      const baseFields = [
        {
          key: "ID",
          label: 'Id', 
          class: 'my-left-border my-left-right my-left-bottom',  
          sortable: true 
        },
        {
          key: "NOME",
          label: 'Nome', 
          class: 'my-left-border my-left-right my-left-bottom',  
          sortable: true 
        }
      ]

      if (this.vendaPorPecas) {
        baseFields.push({
          key: "SALDO_PECAS",
          label: 'Volumes', 
          class: 'text-right my-left-border my-left-right my-left-bottom',  
          sortable: true 
        })
      } else {
        baseFields.push({
          key: "SALDO_QUANT",
          label: 'Peso/UND', 
          class: 'text-right my-left-border my-left-right my-left-bottom',  
          sortable: true 
        })
      }

      return baseFields
    }
  },
  components: {
    VueButtonSpinner,
    Autocomplete
  },
  methods: {
    setId (evt) {
      this.$emit('retornaId', evt)
    },
    clearComplete (obj) {
      this.$emit('retornaId', null)
      this.$emit('retornaNome', null)
      this.$emit('retornaCusto', 0)
    },
    clearModal () {
      this.items = []
      this.pesquisa.id = ''
      this.pesquisa.nome = ''
    },
    selecionar (evt) {
      this.$emit('retornaId', evt.ID)
      this.$emit('retornaNome', evt.CODIGONOME)
      this.$emit('retornaCusto', evt.VL_CUSTO)
      this.clearModal()
      this.$refs.modalProduto.hide()
      // Mudar o display do autocomplete..
      this.$refs.auto.display = evt.CODIGONOME
      this.$refs.auto.selectedDisplay = evt.CODIGONOME
    },
    onSubmit () {
      if ((!this.pesquisa.id) && (!this.pesquisa.nome)) {
        alert('Por Favor! Informe algum texto/valor para pesquisar')
        return
      }
      this.isLoading = true
      this.isBusy = true
      let uri = `/api/protected/produto/localizarComEstoque?idPesquisa=${this.pesquisa.id}&nomePesquisa=${this.pesquisa.nome}`
      let promise = this.$http.get(uri)
      return promise.then((data) => {
        this.items = data.data
        this.isBusy = false
        this.isLoading = false
        this.status = true // or success
        setTimeout(() => {
          this.status = ''
        }, 1000) // to clear the status :)
      }).catch((error) => {
        if (error) {
          this.items = []
          this.isLoading = false
          this.status = false // or error
        }
      })
    },
    atualizaComplete () {
      if (this.idInicial) {
        let uri = `/api/protected/produto/pesquisaridmin?idPesquisa=${this.idInicial}`
        let promise = this.$http.get(uri)
        return promise.then((data) => {
          if (data.data && data.data.length > 0) {
            this.$refs.auto.display = data.data[0].CODIGONOME
            this.$refs.auto.selectedDisplay = data.data[0].CODIGONOME
            this.$refs.auto.value = data.data[0].ID
          }
        })
      }
    },
    atualizaClasse () {
      if (this.classe === '0') {

      }
    },
    limpar() {
      if (this.$refs.auto) {
        this.$refs.auto.clear()
      }
    },
    onSelecionado({ selectedObject }) {
      if (selectedObject) {
        this.$emit('retornaId', selectedObject.ID)
        this.$emit('retornaNome', selectedObject.CODIGONOME)
        this.$emit('retornaCusto', selectedObject.VL_CUSTO)

        // Atualiza visualmente o campo
        this.$refs.auto.display = selectedObject.CODIGONOME
        this.$refs.auto.selectedDisplay = selectedObject.CODIGONOME
        this.$refs.auto.value = selectedObject.ID
      }
    },
  },
  watch: {
    // escuta o idInicial para pesquisar o cliente se o cadastro tiver cliente_id por exemplo
    'idInicial': function () {
      this.atualizaComplete()
    }
  },
  created () {
    this.atualizaComplete()
  }
}
</script>
<style scoped>
.modal-dialog {
  top: 50px
}

.result-item-premium {
    padding: 10px 15px;
    border-bottom: 1px solid #edf2f7;
    cursor: pointer;
    transition: all 0.2s ease;
    border-left: 3px solid transparent;
}

.result-item-premium:hover, .autocomplete__selected {
    background-color: rgba(102, 126, 234, 0.05) !important;
    border-left: 3px solid #667eea !important;
}

.result-info {
    display: flex;
    flex-direction: column;
}

.result-code {
    font-size: 0.7rem;
    font-weight: 800;
    color: #667eea;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

.result-name {
    font-size: 0.9rem;
    font-weight: 600;
    color: #2d3748;
}

.stock-badge {
    font-size: 0.75rem !important;
    padding: 0.4rem 0.8rem !important;
    font-weight: 700 !important;
    min-width: 85px;
    text-align: center;
}

.shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}

.b-table .my-left-border {
  border-left: 1px solid #a4b7c1;
}
.b-table .my-left-right {
  border-right: 1px solid #a4b7c1;
}
.b-table .my-left-bottom {
  border-bottom: 1px solid #a4b7c1;
}
</style>



// WEBPACK FOOTER //
// src/views/pesquisa/ProdutoPesquisaEstoque.vue